import { styled } from "styled-components";
import { Link } from "react-router-dom";
import {
  AiOutlineFileProtect,
  AiOutlineRight,
  AiOutlineSafety,
  AiOutlineSolution,
} from "react-icons/ai";
import { Page } from "../../../components/layout/page/page.component";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { colors } from "../../../theme/colors";
import { Child } from "../../../types/Children";

const policies: {
  label: string;
  description: string;
  link: string;
  icon: Child;
}[] = [
  {
    label: "Privacy Policy",
    description:
      "Learn how we collect, use, and protect your personal information.",
    link: "/privacy-policy",
    icon: <AiOutlineSafety size={24} color={colors.primary.hex} />,
  },
  {
    label: "Terms and Conditions",
    description:
      "Read the terms governing your use of our products and services.",
    link: "/terms-and-conditions",
    icon: <AiOutlineFileProtect size={24} color={colors.primary.hex} />,
  },
  {
    label: "Refund Policy",
    description: "Understand our refund and cancellation guidelines.",
    link: "/refund-policy",
    icon: <AiOutlineSolution size={24} color={colors.primary.hex} />,
  },
];

export const PoliciesPage = () => {
  return (
    <Page>
      <Spacer direction="bottom" size={window.innerWidth <= 768 ? 40 : 0} />
      <Title>Policies</Title>
      <Subtitle>
        Review the documents that govern your use of Pocketfilms.
      </Subtitle>
      <Spacer direction="bottom" size={30} />
      <List>
        {policies.map((policy) => (
          <PolicyItem key={policy.link} to={policy.link}>
            <IconWrapper>{policy.icon}</IconWrapper>
            <TextBlock>
              <PolicyLabel>{policy.label}</PolicyLabel>
              <PolicyDescription>{policy.description}</PolicyDescription>
            </TextBlock>
            <AiOutlineRight size={18} color={colors.text.hex} />
          </PolicyItem>
        ))}
      </List>
    </Page>
  );
};

const Title = styled.h1`
  font-size: 4rem;
  font-weight: 600;
`;

const Subtitle = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
  color: ${colors.text.withOpacity(0.7).hex};
  margin-top: 0.5rem;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;

const PolicyItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
  background-color: ${colors.background.hex};
  border-radius: 0.5rem;
  box-shadow: 10px 10px 80px ${colors.whiteShadow.hex};
  text-decoration: none;
  color: ${colors.text.hex};
  transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 12px 12px 100px ${colors.whiteShadow.hex};
  }
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background-color: ${colors.primary.withOpacity(0.1).hex};
  flex-shrink: 0;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.4rem;
`;

const PolicyLabel = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
`;

const PolicyDescription = styled.p`
  font-size: 1.35rem;
  font-weight: 400;
  color: ${colors.text.withOpacity(0.7).hex};
`;
